import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { animateScroll } from 'react-scroll';
import { Button, colors } from 'z-react-components';

export const styles = {
    boxStyle: {
        height: 400,
        border: `1px solid ${colors.grey500}`,
        background: colors.white,
        textAlign: 'center',
        overflow: 'hidden'
    },
    descriptionHeight: {
        height: 120,
        marginTop: 10
    },
    imgStyle: {
        marginTop: 40,
        width: '15%'
    },
    titleStyle: {
        marginTop: 15
    },
    cornerRibbon: {
        backgroundColor: colors.red,
        color: colors.white,
        width: 200,
        position: 'absolute',
        top: 30,
        left: -50,
        textAlign: 'center',
        lineHeight: '30px',
        transform: 'rotate(-45deg)'
    },
    buttonStyle: {
        border: 'none',
        textTransform: 'uppercase',
        backgroundColor: colors.orange,
        color: colors.white
    }
};
export default class Box extends Component {
    static propTypes = {
        btnLabel: PropTypes.string,
        description: PropTypes.string,
        iconUrl: PropTypes.string,
        isComingSoon: PropTypes.bool,
        title: PropTypes.string,
        url: PropTypes.string
    };

    static defaultProps = {
        isComingSoon: false
    };

    render() {
        const { btnLabel, description, iconUrl, isComingSoon, title, url } = this.props;
        return (
            <Col sm={4} style={styles.boxStyle} xs={12}>
                {isComingSoon ? (
                    <div className="box-is-coming-soon" style={styles.cornerRibbon}>
                        {'Presto in arrivo'}
                    </div>
                ) : null}
                <Col sm={12}>
                    <img alt="box_icon" className="box-icon" src={iconUrl} style={styles.imgStyle} />
                </Col>
                <Col className="box-title" sm={12} style={styles.titleStyle}>
                    <h4>
                        <b>{title}</b>
                    </h4>
                </Col>
                <Col className="box-description" sm={12} style={styles.descriptionHeight}>
                    {description}
                </Col>
                <Col sm={12}>
                    <Link to={url}>
                        <Button className="linkButton" onClick={() => animateScroll.scrollToTop({ duration: 200 })} style={styles.buttonStyle}>
                            {btnLabel}
                        </Button>
                    </Link>
                </Col>
            </Col>
        );
    }
}
